import React from 'react';
// import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
import bindAllActions from '../../common/bindAllActions';
import { PlusSubscriptionSelector, CameraSubscriptionSelector, HeatStressSubscriptionSelector, subIsTeams } from './index';
import SubscriptionTabs from './SubscriptionTabs';
import StepIndicator from './StepIndicator';
import { useDeviceIdRedirect } from './useDeviceIdRedirect';
import { useCanShowExternalPurchaseLinks } from '../device/redux/useCanShowExternalPurchaseLinks';
import './SubscribePage.less';

function SubscribePage({ user, device }) {
  const { canShowExternalPurchaseLinks } = useCanShowExternalPurchaseLinks();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const type = params.get('type');
  const deviceId = params.get('deviceId');
  const isChangePlan = params.get('changePlan') === 'true';
  const isCamera = type === 'camera';
  const isHeatStress = type === 'heat-stress';

  // Handle MAC address in deviceId - redirect to proper device ID
  useDeviceIdRedirect(deviceId, device);

  // For camera subscriptions, look up the specific device
  // Default to the first device if no deviceId specified
  const currentDevice = React.useMemo(() => {
    if (!isCamera) return null;
    if (deviceId && device?.devices) {
      // First try to find by _id
      let foundDevice = device.devices.find(d => d._id === deviceId);
      // If not found and deviceId looks like a MAC address, try that
      if (!foundDevice && deviceId.includes(':')) {
        foundDevice = device.devices.find(d => d.macAddress === deviceId);
      }
      return foundDevice;
    }
    // Default to first device if no deviceId specified
    return device?.devices?.[0];
  }, [isCamera, deviceId, device]);

  // Determine if we should show upgrade or downgrade preview for AWN+ subscriptions
  // Suppress previews when navigating from "Change Plan" so the full selector is shown
  const showUpgradePreview = !isChangePlan && !isCamera && !isHeatStress && user?.plus && !subIsTeams(user.plus);
  const showDowngradePreview = !isChangePlan && !isCamera && !isHeatStress && user?.plus && subIsTeams(user.plus);

  // Determine page title based on subscription type
  const getPageTitle = () => {
    if (isCamera) return 'Subscribe to Camera Plans';
    if (isHeatStress) return 'Subscribe to Heat Stress Plans';
    return 'Subscribe to AWN+';
  };

  return (
    <div className="payment-subscribe-page">
      <header className='main'>
        <h1>{getPageTitle()}</h1>
      </header>
      <SubscriptionTabs currentTab="manage" />
      <div className='page-body'>
        <div className='block'>
          <StepIndicator currentStep={1} cancelLink='/subscriptions' />
          {isCamera ? (
            <CameraSubscriptionSelector
              user={user}
              currentDevice={currentDevice}
            />
          ) : isHeatStress ? (
            <HeatStressSubscriptionSelector
              user={user}
            />
          ) : (
            <PlusSubscriptionSelector
              user={user}
              device={device}
              showGiftCodeLink={canShowExternalPurchaseLinks}
              showUpgradePreview={showUpgradePreview}
              showDowngradePreview={showDowngradePreview}
            />
          )}
        </div>
      </div>
    </div>
  );
}

export default bindAllActions(SubscribePage);

SubscribePage.propTypes = {};
SubscribePage.defaultProps = {};

SubscribePage.displayName = 'SubscribePage'
